import React, { useMemo } from 'react'
import { EarlyWarningsData } from '../GeneralInformation/typesExtendedReport'

export const useEarlyWarningsData = (data: EarlyWarningsData | null | undefined) => {

    return useMemo(() => {
        if (!data) return null

        return {
            RecentIssuses: data.recentIssuses,
            ProjectPendingSignedAlertTypes: data.projectPendingSignedAlertTypes,
            ProjectLastDisbursementDateExpired: data.projectLastDisbursementDateExpired,
            EsgSafeGuardPerformanceRating: data.esgSafeGuardPerformanceRating,
            ProjectPartialCancellations: data.projectPartialCancellations,
            ProjectElegibleFirstUndisbursement: data.projectElegibleFirstUndisbursement,
            GcmAlerts: data.gcmAlerts,
        }
    }, [data])
}
